const leadPreferences = {
  leadPreferences: {
    pageHeader: 'Leads génération',
    confirmMessage:
      'Êtes-vous sûr de vouloir enregistrer vos préférences de prospects et d’aller sur la page Ajouter un utilisateur ?',
    notInterested: {
      radioOptions0: 'Manque de temps/ressources pour servir les nouveaux prospects',
      radioOptions1: 'Uniquement intéressé par des contrats de propriétaire signés',
      radioOptions2: 'Ne veut pas révéler la gamme de prix',
      radioOptions3: 'Autre',
      selectReason: 'Veuillez sélectionner une raison de ne pas adhérer au programme de prospects Enphase',
      otherComments: 'Autre commentaire'
    },
    programOverview: {
      notInterestedText: `La participation au Programme des prospects d'Enphase ne nous intéresse pas pour le moment`
    },
    serviceDetailsSection: {
      min: 'Min',
      max: 'Max',
      maxLessMin: 'La valeur maximum ne peut être inférieure ou égale à la valeur minimum',
      enterInRange: 'Veuillez saisir uniquement des nombres entre %{serviceMInValue} et %{serviceMaxValue}',
      note: 'Note',
      noteText:
        'Une gamme de prix sera montrée au propriétaire selon ces données. Le prix doit inclure les taxes, mais pas les incitations.',
      noteTextAus:
        'Une gamme de prix sera montrée au propriétaire selon ces données. Le prix doit inclure la TPS, mais pas les incitations.',
      sizeRange: 'Gamme de taille',
      pricePerkWh: 'Prix par kWh',
      lessThan20kWh: 'Moins de 20 kWh',
      greaterThan20kWh: 'De 20 à 40 kWh'
    },
    serviceAreaSection: {
      title: 'Accès administrateur et zones de service',
      manageAdminAccess: 'Gérer l’accès administrateur',
      addNewUser: '+ Ajouter un nouvel utilisateur',
      selectOneAdmin:
        'Veuillez sélectionner un utilisateur administrateur de votre société qui sera le seul point de contact si Enphase souhaite vous contacter pour faire remonter les informations relatives à un prospect.',
      selectUser: 'Sélectionner un utilisateur',
      otherAdmin:
        '#Les autres utilisateurs administrateurs de la liste ci-dessus recevront toujours des alertes concernant les nouveaux prospects et leur mise à jour. Ils peuvent les désactiver en mettant à jour leurs préférences de notification au besoin.',
      serviceArea: 'Zones de service',
      addServiceAreas: ''
    },
    addUserDialog: {
      yes: 'Oui'
    },
    acModule: {
      optIn: 'Choisissez l’installation de Modules alimentés en AC d’Enphase',
      description:
        'Le propriétaire exprime son intérêt pour un système basé sur un module AC. Vous lui procurerez et installerez les modules AC. Les modules alimentés en AC d’Enphase combinent la dernière technologie de pointe de micro-onduleur d’Enphase avec des panneaux photovoltaïques à haut rendement. Ils réunissent esthétique et performance en un produit élégant qui réduit le temps d’installation en combinant l’onduleur et le panneau en une seule unité.'
    },
    sampleQuotes: {
      title: 'Tarif indicatif pour les prospects',
      useSlider:
        'Utilisez les curseurs ci-dessous pour voir la manière dont les données sur votre gamme de prix seront transcrites en gamme de prix indicative pour les propriétaires pour les différentes tailles de système',
      description:
        'Le niveau de prix indicatif basées sur vos données seront communiquer aux propriétaires. Vous pouvez vérifier la manière dont la gamme de prix variera selon la puissance du système.',
      solarOnly: 'Installation de panneaux solaires',
      storageOnly: 'Installation d’un système de stockage',
      solarStorage: 'Installation de panneaux solaires + système de stockage',
      solarExpansion: 'Expansion des panneaux solaires',
      turnkeyACM: 'Installation d’un système de stockage + Mise à niveau ACM',
      microUpgrade: 'Mise à niveau des micro-onduleurs',
      turnkeyIQSeries: 'Installation d’un système de stockage + Mise à niveau des micro-onduleurs',
      installationACM: 'Installation d’un système de stockage + Mise à niveau ACM',
      installationIQSeries: 'Installation d’un système de stockage + Mise à niveau des micro-onduleurs',
      installationSolar: 'Installation de panneaux solaires',
      installationStorage: 'Installation/expansion du système de stockage',
      turnkeyNew: 'Prix clé en main pour les nouveaux propriétaires',
      turnKeyExisting: 'Prix clé en main pour les propriétaires existants',
      turnkeyNewUS: 'Prix clé en main pour les propriétaires',
      installationUS: 'Prix pour l’installation uniquement pour les propriétaires',
      installation: 'Devis de l’installation seule pour les clients des micro M series',
      turnkeyPrice: 'Prix clé en main',
      installation2: 'Prix de l’installation seule pour les clients bénéficiant d’un parrainage',
      installation3: 'Prix pour l’installateur seule pour les propriétaires existants',
      microinverterFootnote: 'Le prix de mise à niveau des micro-onduleurs peut être ajouté selon l’âge du site',
      solar: 'Le solaire',
      storage: 'Le stockage'
    },
    operationMaintenance: {
      label: 'Choisissez les services F&E',
      description:
        'Les services de opération et maintenance (O&M) incluent le support et l’entretien des systèmes Enphase existants et orphelins (sites avec un installateur inactif). Tous les prospects aux services O&M seront fournis avec l’ensemble des détails du site et de l’historique de support. Pour tous les prospects aux services O&M, la garantie standard des produits Enphase s’appliquera. La précédente garantie d’installation ne s’appliquera pas aux systèmes orphelins.'
    },
    leadProgram: {
      optIn: 'Choisissez le Programme de prospects Enphase',
      description:
        'Les propriétaires contactent Enphase pour de nouvelles installations, des mises à niveau et une maintenance continue de leur système. En tant que partenaire Enphase, vous avez désormais l’opportunité de servir ces propriétaires, grâce au Programme de prospects Enphase, qui vous associera à des propriétaires prospects.',
      programHighlights: 'Points forts du programme :',
      keyTerms1: 'Enphase vous fournira gratuitement des prospects qualifiés dans votre périmètre d’action',
      keyTerms2:
        'Le profil du client et les détails du projet seront fournis pour chaque prospect avant le premier contact',
      keyTerms3:
        'Enphase vous assistera dans la programmation, la prise de rendez-vous, les mises à jour du projet et le support technique',
      keyTerms4:
        'Les installateurs sont censés répondre à et contacter chaque prospect, ainsi que leur envoyer un devis dans les 2 jours ouvrables',
      keyTerms5: 'Dans le cadre du programme, seuls les produits Enphase seront utilisés',
      leadProgramPreferences: 'Préférence de leads',
      someLeads:
        'Certains prospects pourraient n’avoir besoin que de services d’installation. Veuillez indiquer ci-dessous si vous voulez choisir ces prospects-là.',
      tooltipTitle1:
        'Services que vous fournissez aux propriétaires. Enphase vous associera aux propriétaires selon les préférences de service que vous avez sélectionnées',
      turnKey: 'Services clé en main',
      tooltipTitle2: 'Vous fournissez tous les services d’équipement, de conception, de permission et d’installation',
      installationService: 'Services d’installation uniquement',
      tooltipTitle3:
        'Le propriétaire choisit de se procurer un équipement Enphase depuis le magasin Enphase. Vous fornissez les services d’équipement, de conception, de permission et d’installation restants',
      solarNew: 'Solaire – Nouvelles installations',
      solarUpgrades: 'Solaire - Mises à niveau',
      storageNew: 'Stockage - Nouvelles installations'
    },
    textContent: {
      preference: {
        title: 'Préférence de leads',
        caption: 'Clause de non-responsabilité',
        description:
          'Enphase affichera aux propriétaires la fourchette de prix que vous avez fournie pour chaque service ci-dessous. Elle sera accompagnée d’une clause de non-responsabilité indiquant que ces prix sont donnés à titre indicatif. La tarification réelle sera dépendante de la localisation, du type de toiture, de son inclinaison, du type de panneau photovoltaïque et de l’emplacement du coffret de protection.\u200b',
        atleaseOne: '* sélectionnez au moins un service'
      },
      programreview: {
        title: 'Aperçu du programme',
        description:
          'Les propriétaires contactent Enphase pour de nouvelles installations, des mises à niveau et une maintenance continue de leur système. En tant que partenaire Enphase, vous avez désormais l’opportunité de servir ces propriétaires, grâce au Programme de prospects Enphase, qui vous associera à des propriétaires prospects. Veuillez examiner les conditions clés ci-dessous et préciser vos préférences pour ce programme.'
      },
      keyProgramTerms: {
        title: 'Conditions clés du programme',
        enphaseProduct: 'Dans le cadre du programme, seuls les produits Enphase seront utilisés',
        appointment:
          'Enphase vous assistera dans la programmation des rendez-vous et vous fournira toute autre forme d’assistance au besoin',
        contact: 'Vous devez contacter chaque prospect dans les 2 jours ouvrables',
        project:
          'Le profil du client et les détails du projet seront fournis pour chaque prospect avant le premier contact',
        verifiedAccount: 'Enphase vous fournira gratuitement des prospects qualifiés dans votre périmètre d’action'
      },
      TurnKey: {
        title: 'Services clé en main',
        description:
          'L’offre de services clé en main signifient que l’installateur fera la conception, la fourniture du matériel et l’assistance administrative jusqu’à la mise en service du système. L’installateur effectue une évaluation du projet et du site avant de fournir un devis détaillé. Le prix indiqué inclut le coût estimé total que le propriétaire devra payer pour l’activation de son système.',
        solar: {
          indicativePricing: 'Gamme de prix indicatif par Watt',
          quoteSizeIn: 'kW',
          main: 'Système – Installation',
          sub: 'Installations d’un nouveau système photovoltaïque.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Fournit une tarification clé en main et se procure tous les éléments du système tel que les modules, les micro-onduleurs (ou bien les modules AC), le coffret de protection,  les accessoires, les câbles et les systèmes de montage.'
            },
            assumptions: {
              main: 'Nota bene',
              sub: 'La gamme de prix n’inclut pas la réfaction de toiture ou mise à niveau du tableau électrique.'
            }
          }
        },
        storage: {
          indicativePricing: 'Gamme de prix indicative par kWhr',
          indicativePricingStorageSlabs: 'Prix indicatif par kWh',
          main: 'Stockage - Installation',
          quoteSizeIn: 'kWh',
          sub: 'Installation d’un nouveau système de stockage',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Fournit une tarification clé en main et fournit tous les éléments nécessaires au système tels que le stockage Encharge, le coffret de protection ou Enpower box, les accessoires et les câbles​\u200b.'
            },
            assumptions: {
              main: 'Nota bene',
              sub: 'La gamme de prix n’inclut pas la mise à niveau du tableau électrique.'
            }
          }
        },
        microinverter: {
          indicativePricing: 'Gamme de prix indicatif par Watt',
          main: 'Micro-onduleur - Mise à jour',
          quoteSizeIn: 'kW',
          sub:
            'Mise à jour des micro-onduleurs pour un système installé en M série (par exemple M-215, M-250) vers un  système en IQ série',
          sub2:
            'Mise à niveau des micro-onduleurs pour un système de panneaux solaires basé sur une série M (par exemple M-215, M-250) vers un nouveau système de panneaux solaires basé sur une série IQ',
          subUS:
            'La mise à niveau des micro-onduleurs pour un système solaire existant pour les convertir à un nouveau système solaire à base de série IQ.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Fournit une tarification clé en main et fournit tous les éléments nécessaires à la mise à jour.'
            },
            assumptions: {
              main: 'Nota bene',
              sub:
                'La gamme de prix indicative n’inclut pas la mise à niveau du tableau électrique et les mises à niveau des panneaux solaires.'
            }
          }
        }
      },
      installationOnly: {
        title: 'Services d’installation seule (pour les programmes spéciaux)',
        titleUS: 'Services d’installation uniquement',
        sub: '(Par exemple Propriétaires avec des panneaux solaires basés sur la série M-190, amis et famille Enphase)',
        description:
          'Les services d’installation seule signifient que le propriétaire se procure tous les éléments de la nomenclature Enphase. Tous les autres matériaux et services sont fournis directement par l’installateur (conception, panneau, système de montage, câbles, coffret de protection, suivi administratif, installation et mise en service).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Gamme de prix indicative pour l’installation seule par Watt',
          main: 'Système – Installation',
          sub:
            'Nouvelle installation pour les programmes spéciaux ou mise à niveau complète pour un système de panneaux solaires basé sur les séries M-190/M-210/M-175/D380',
          subUS: 'Installations d’un nouveau système photovoltaïque.',
          details: {
            homeOwner: {
              main: 'Propriétaire',
              sub:
                'Achète les éléments nécessaires de la nomenclature tels que les micro-onduleurs , modules AC, les accessoires.'
            },
            installer: {
              main: 'Installateur',
              sub:
                'Fournit le système de montage, les câbles, coffret de protection, suivi administratif, installation et mise en service.'
            },
            assumptions: {
              main: 'Nota bene',
              sub:
                'La gamme de prix indicative n’inclut pas la mise à niveau du tableau électrique et réfaction de toiture\u200b.'
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Gamme de prix indicative pour l’installation seule par kWhr',
          indicativePricingStorageSlabs: 'Prix indicatif pour l’installation uniquement par kWh',
          main: 'Stockage - Installation',
          sub:
            'Ajout de capacité de stockage à un système de panneaux solaire existant pour les programmes spéciaux ou pour un système de panneaux solaires basé sur les M série ou IQ série',
          subUS: 'Installation d’un nouveau système de stockage',
          details: {
            homeOwner: {
              main: 'Propriétaire',
              sub:
                'Achète les éléments nécessaires de la nomenclature tels que le stockage Encharge, l’ Enpower box, les accessoires, la passerelle Envoy​\u200b.'
            },
            installer: {
              main: 'Installateur',
              sub: 'Fournit le suivi administratif, l’installation et la mise en service.'
            },
            assumptions: {
              main: 'Nota bene',
              sub: 'La gamme de prix n’inclut pas la mise à niveau du tableau électrique.'
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Gamme de prix indicative pour l’installation seule par Watt',
          main: 'Micro-onduleurs - Mise à niveau',
          sub: `Mise à jour des micro-onduleurs pour un système installé en M série (par exemple M-215, M-250) vers un  système en IQ série"`,
          sub2:
            'Actualización del microinversor para un sistema solar basado en la serie M (por ejemplo, M-215, M-250) a un nuevo sistema solar basado en IQ',
          subUS:
            'La mise à niveau des micro-onduleurs pour un système solaire existant pour les convertir à un nouveau système solaire à base de série IQ.',
          details: {
            homeOwner: {
              main: 'Propriétaire',
              sub:
                'Achète les éléments nécessaires de la nomenclature ENPHASE tels que les micro-onduleurs, les accessoires.'
            },
            installer: {
              main: 'Installateur',
              sub:
                'Fournit le suivi administratif, le remplacement, la remise en service et le recyclage des anciens micro-onduleurs.\u200b'
            },
            assumptions: {
              main: 'Nota bene',
              sub: 'La gamme de prix n’inclut pas la mise à niveau du tableau électrique et les changements de racks.'
            }
          }
        }
      },
      omServices: {
        title: 'Services O&M',
        om: {
          main: 'Service O&M',
          pre: '- Y compris les systèmes orphelins',
          sub:
            'Les services de opération et maintenance (O&M) incluent le support et l’entretien des systèmes Enphase existants et orphelins (sites avec un installateur inactif). Tous les prospects aux services O&M seront fournis avec l’ensemble des détails du site et de l’historique de support. Pour tous les prospects aux services O&M, la garantie standard des produits Enphase s’appliquera. La précédente garantie d’installation ne s’appliquera pas aux systèmes orphelins.'
        }
      },
      otherServices: {
        title: 'Autres préférences',
        buy: 'Nous sommes prêts à acheter les produits de',
        acModule: {
          main: `Nous sommes prêts à installer les modules AC alimentés d'Enphase`,
          sub1: 'Les modules AC\xa0',
          sub2:
            'combinent la toute dernière technologie de micro-onduleurs d’Enphase avec des panneaux photovoltaïques. Ils réunissent esthétique et performance en un produit élégant qui réduit le temps d’installation en combinant l’onduleur et le panneau en une seule unité. En sélectionnant cette option, Enphase vous mettra en contact avec des propriétaires qui souhaitent installer des modules AC.'
        },
        enstore: {
          main: 'L’E-Store',
          sub1: 'L’E-Store\xa0',
          sub2:
            'est un guichet unique pour les produits solaires et de stockage avec une livraison. L’E-STore n’exige aucune quantité minimum de commande et fournit une livraison en temps réel, ainsi qu’un suivi en ligne.\u200b',
          subIndia: `is a one-stop-shop for Solar products with guaranteed delivery. Store requires no minimum order quantity and provides real time delivery and online tracking.​`
        },
        distributor: {
          main: 'Distributeurs Enphase',
          sub1: 'Distributeurs Enphase',
          sub2:
            '\xa0fournissent tous les produits Enphase et d’autres accessoires nécessaires à votre solution solaire et de stockage\u200b',
          subIndia: ` supply all Enphase products and other required accessories for your Solar solution​`
        },
        permitAssistance: {
          main: `Nous nous intéressons au Service d'assistance aux permis d'Enphase`,
          sub:
            'Enphase vous assistera grâce à des Packs de permis pour les systèmes solaires et de stockage pour vos sites, packs que vous pouvez ensuite envoyer à vos autorités locales pour obtenir leur approbation.'
        },
        financeProvider: {
          main: 'Nous fournissons des options de financement pour les propriétaires',
          no: 'Non',
          yes: 'Oui',
          financeProvider: 'Bailleurs de fonds',
          others: 'Autres prestataires',
          addMultiple: 'jusqu’à 3 (séparé par une virgule)',
          requiredSelection: 'Sélection requise',
          atLeastOneError: `Fournisseurs de financement non valides (entrez au moins un nom de fournisseur lorsque "Autres fournisseurs" est sélectionné)`
        }
      },
      serviceArea: {
        name: 'AJOUTER DES ZONES DE SERVICE',
        sub: 'Aucune zone ajoutée',
        description:
          'Veuillez ajouter vos zones de service. Ce champ est nécessaire pour qu’Enphase puisse vous mettre en contact avec des propriétaires prospects.'
      },
      qualifyLeads: {
        mainSection: 'Voulez-vous que les représentants d’Enphase qualifient les leads par téléphone avant de vous les transmettre?',
        moreInfo: 'N’hésitez pas à nous faire savoir si vous souhaitez que nous collections certaines informations auprès de vos leads.',
        infoWeCollect: 'Pour savoir quelles informations nous collectons dans le cadre de notre processus de qualification',
        subSection: 'Au moment de la qualification, lorsque nous sommes en communication avec le ou la propriétaire, voulez-vous que le lead soit transféré vers vos représentants?',
        details: 'Veuillez désigner un administrateur au sein de votre entreprise vers lequel ces leads devront être transférés',
        icCheckList: 'Qualification Checklist',
        selectOption: 'Please select an option',
        selectUser: 'Please select a user',
      }
    },
    textContentAu: {
      preference: {
        title: 'Préférence de leads',
        caption: 'Clause de non-responsabilité',
        description:
          'Enphase affichera aux propriétaires la fourchette de prix que vous avez fournie pour chaque service ci-dessous. Elle sera accompagnée d’une clause de non-responsabilité indiquant que ces prix sont donnés à titre indicatif. La tarification réelle sera dépendante de la localisation, du type de toiture, de son inclinaison, du type de panneau photovoltaïque et de l’emplacement du coffret de protection.\u200b',
        atleaseOne: '* sélectionnez au moins un service'
      },
      programreview: {
        title: 'Aperçu du programme',
        description:
          'Les propriétaires contactent Enphase pour de nouvelles installations, des mises à niveau et une maintenance continue de leur système. En tant que partenaire Enphase, vous avez désormais l’opportunité de servir ces propriétaires, grâce au Programme de prospects Enphase, qui vous associera à des propriétaires prospects. Veuillez examiner les conditions clés ci-dessous et préciser vos préférences pour ce programme.'
      },
      keyProgramTerms: {
        title: 'Conditions clés du programme',
        enphaseProduct: 'Dans le cadre du programme, seuls les produits Enphase seront utilisés',
        appointment:
          'Enphase vous assistera dans la programmation des rendez-vous et vous fournira toute autre forme d’assistance au besoin',
        contact: 'Vous devez contacter chaque prospect dans les 2 jours ouvrables',
        project:
          'Le profil du client et les détails du projet seront fournis pour chaque prospect avant le premier contact',
        verifiedAccount: 'Enphase vous fournira gratuitement des prospects qualifiés dans votre périmètre d’action'
      },
      TurnKey: {
        title: 'Services clé en main',
        description:
          'Les services clé en main comprennent la fourniture des éléments de la nomenclature, la conception du système, les permissions, l’installation et la mise en service, selon le cas. L’installateur effectue une évaluation du projet et du site avant de fournir un devis détaillé. Le prix indiqué doit inclure le coût estimé total facturé au propriétaire pour l’activation du système',
        solar: {
          indicativePricing: 'Gamme de prix indicatif par Watt',
          quoteSizeIn: 'kW',
          main: 'Système – Installation',
          sub: 'Installations d’un nouveau système photovoltaïque.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Fournit une tarification clé en main et fournit tous les éléments nécessaires à la mise à jour tels que les modules, les micro-onduleurs, les accessoires, les disjoncteurs, le modem cellulaire, les câbles et les racks.'
            },
            assumptions: {
              main: 'Nota bene',
              sub: 'La gamme de prix n’inclut pas la réfaction de toiture ou mise à niveau du tableau électrique.'
            }
          }
        },
        storage: {
          indicativePricing: 'Gamme de prix indicative par kWhr',
          main: 'Stockage - Installation',
          quoteSizeIn: 'kWh',
          sub: 'Installation d’un nouveau système de stockage',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Fournit une tarification clé en mail et se procure tous les éléments nécessaires de la nomenclature tels que le stockage ACB, les supports, les câbles et les disjoncteurs.'
            },
            assumptions: {
              principal: "'Nota bene",
              sub: 'La gamme de prix indicative n’inclut pas la mise à niveau du panneau principal.'
            }
          }
        },
        microinverter: {
          indicativePricing: "'Gamme de prix indicative par Watt",
          main: 'Micro-onduleur - Mise à jour',
          quoteSizeIn: 'kW',
          sub:
            'Mise à niveau des micro-onduleurs pour un système de panneaux solaires basé sur une série M (par exemple M-215, M-250) vers un nouveau système de panneaux solaires basé sur la série IQ qui accompagne généralement l’option «\xa0Stockage - Installation\xa0»',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Fournit une tarification clé en main et fournit tous les éléments nécessaires à la mise à jour.'
            },
            assumptions: {
              main: 'Nota bene',
              sub:
                'La gamme de prix indicative n’inclut pas la mise à niveau du tableau électrique et les mises à niveau des panneaux solaires.'
            }
          }
        },
        solarExpansion: {
          indicativePricing: 'Gamme de prix indicatif par Watt',
          quoteSizeIn: 'kW',
          main: 'Expansion du système de panneaux solaires',
          sub: 'Expansion de systèmes de panneaux solaires existants Enphase et non Enphase',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Fournit une tarification clé en main et fournit tous les éléments nécessaires à la mise à jour.'
            },
            assumptions: {
              main: 'Nota bene',
              sub: 'La gamme de prix n’inclut pas la réfaction de toiture ou mise à niveau du tableau électrique.'
            }
          }
        }
      },
      installationOnly: {
        title: 'Services d’installation seule (pour les programmes spéciaux)',
        sub:
          '(par exemple les systèmes orphelins ont besoin d’un remplacement/d’une réparation, d’une mise à niveau de batterie, d’une mise à niveau de l’Envoy)',
        description:
          'Les services d’installation seule signifient que le propriétaire se procure tous les éléments de la nomenclature Enphase. Tous les autres matériaux et services sont fournis directement par l’installateur (conception, panneau, système de montage, câbles, coffret de protection, suivi administratif, installation et mise en service).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Gamme de prix indicative pour l’installation seule par Watt',
          main: 'Système – Installation',
          sub:
            'Nouvelles installations pour les programmes spéciaux tels que les prospects issus de parrainage par des clients, des installateurs et des employés Enphase.',
          details: {
            homeOwner: {
              main: 'Propriétaire',
              sub:
                'Achète les éléments nécessaires de la nomenclature dans un magasin Enphase tels que les micro-onduleurs, le kit d’accessoires, l’Envoy et les disjoncteurs.'
            },
            installer: {
              main: 'Installateur',
              sub: 'Fournit les modules, les racks, les câbles, les permissions, l’installation et la mise en service.'
            },
            assumptions: {
              main: 'Nota bene',
              sub:
                'La gamme de prix indicative n’inclut pas la mise à niveau du tableau électrique et réfaction de toiture\u200b.'
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Gamme de prix indicative pour l’installation seule par kWhr',
          main: 'Stockage – Expansion ou Installation',
          sub:
            'Expansion ou installation de stockage ACB dans un système de panneaux solaires existant pour les programmes spéciaux',
          details: {
            homeOwner: {
              main: 'Propriétaire',
              sub:
                'Achète les éléments nécessaires de la nomenclature dans un magasin Enphase tels que le stockage ACB, le support\u200b.'
            },
            installer: {
              main: 'Installateur',
              sub: 'Fournit l’installation et la mise en service.'
            },
            assumptions: {
              main: 'Nota bene',
              sub: 'La gamme de prix n’inclut pas la mise à niveau du tableau électrique.'
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Gamme de prix indicative pour l’installation seule par Watt',
          main: 'Micro-onduleurs - Mise à niveau',
          sub:
            'Mise à niveau des micro-onduleurs pour un système de panneaux solaires basé sur une série M-190/M-210/M-175/D380 vers un nouveau système de panneaux solaires basé sur une série IQ qui accompagne généralement l’option «\xa0Stockage - Installation\xa0»',
          details: {
            homeOwner: {
              main: 'Propriétaire',
              sub:
                'Achète les éléments nécessaires de la nomenclature dans un magasin Enphase tels que les micro-onduleurs, le coffret de regroupement IQ, le kit d’accessoires et les disjoncteurs.\u200b'
            },
            installer: {
              main: 'Installateur',
              sub:
                'Fournit le suivi administratif, le remplacement, la remise en service et le recyclage des anciens micro-onduleurs.\u200b'
            },
            assumptions: {
              main: 'Nota bene',
              sub:
                'La gamme de prix n’inclut pas la mise à niveau du tableau électrique et le changement des système de montage.'
            }
          }
        }
      },
      omServices: {
        title: 'Services O&M',
        om: {
          main: 'Service O&M',
          pre: '- Y compris les systèmes orphelins',
          sub:
            'Les services de Fonctionnement et entretien (F&E) incluent le support et l’entretien des systèmes Enphase existants et des systèmes orphelins (sites avec un installateur inactif). Tous les prospects aux services F&E seront fournis avec l’ensemble des détails du site et de l’historique de support. Pour tous les prospects aux services F&E, la garantie standard des produits Enphase s’appliquera.'
        }
      },
      otherServices: {
        title: 'Autres préférences',
        buy: 'Je souhaite acheter les produits',
        acModule: {
          main: 'Je souhaite installer des modules AC',
          sub1: 'Les modules AC\xa0',
          sub2:
            'combinent la toute dernière technologie de micro-onduleurs d’Enphase avec des panneaux photovoltaïques. Ils réunissent esthétique et performance en un produit élégant qui réduit le temps d’installation en combinant l’onduleur et le panneau en une seule unité. En sélectionnant cette option, Enphase vous mettra en contact avec des propriétaires qui souhaitent installer des modules AC.'
        },
        enstore: {
          main: 'L’E-Store',
          sub1: 'L’E-Store \xa0',
          sub2:
            'est un guichet unique pour les produits solaires et de stockage avec une livraison. L’E-STore n’exige aucune quantité minimum de commande et fournit une livraison en temps réel, ainsi qu’un suivi en ligne.\u200b'
        },
        distributor: {
          main: 'Distributeurs Enphase',
          sub1: 'Distributeurs Enphase',
          sub2:
            '\xa0fournissent tous les produits Enphase et d’autres accessoires nécessaires à votre solution solaire et de stockage\u200b'
        }
      },
      serviceArea: {
        name: 'AJOUTER DES ZONES DE SERVICE',
        sub: 'Aucune zone ajoutée',
        description:
          'Veuillez ajouter vos zones de service. Ce champ est nécessaire pour qu’Enphase puisse vous mettre en contact avec des propriétaires prospects.'
      }
    },
    getLink: `Obtenir le lien`,
    linkSENewLeads: `Lien d’Estimateur de système pour nouveaux prospects`,
    shareSELink: `Partagez ce lien avec vos clients pour les aider à estimer la taille de leur système Enphase et envoyer leurs détails pour obtenir un prospect dans votre Enlighten Manager`
  }
};

export default leadPreferences;
